<div id="office-locations-main" data-cy="referral-client-container">
  <mat-progress-spinner
    style="margin-left: auto; margin-right: auto; position: relative; top: 50%; transform: translateY(-50%)"
    diameter="100" mode="indeterminate" *ngIf="!listReferralEntities" data-cy="referral-client-loading-spinner"></mat-progress-spinner>
  <mat-grid-list *ngIf="listReferralEntities" cols="6" rowHeight="100%" style="height:100%;" data-cy="referral-client-grid">
    <mat-grid-tile colspan="2" data-cy="referral-client-list-tile">
      <mat-card appearance="outlined" style="width:100%; height:100%;" data-cy="referral-client-list-card">
        <div style="height: 100%; display: flex; flex-direction: column;" data-cy="referral-client-list-content">
          <span style="flex-basis: fit-content;" class="configuration-section-title" data-cy="referral-client-list-title">Referral Clients</span>
          <div style="flex-basis: fit-content;" data-cy="referral-client-dropdown-container">
            <app-tdo-dropdown placeholder="Practice (Licensee)"
                              [dataSource]="clientList"
                              dataSourceDisplayKey="Name"
                              [isObjectValue]="true"
                              [value]="selectedClient"
                              (selectionChange)="onChangeClient($event)"
                              data-cy="referral-client-practice-dropdown">
            </app-tdo-dropdown>
          </div>
          <div style="flex: 1;" data-cy="referral-client-table-container">
            <tdo-table #ReferralEntityTable *ngIf="listReferralEntities"
                       [sortActive]="'ReferralClientName'"
                       [sortDirection]="'asc'"
                       [searchPredicate]="searchPredicate"
                       [dataSource]="listReferralEntities"
                       (rowSelected)="onRowSelected($event)"
                       data-cy="referral-client-table">
              <tdo-table-column [rowTemplate]="name" [isSortable]="true" displayName="Referral Entity Name"
                                propertyName="ReferralClientName" data-cy="referral-client-name-column">
                <ng-template #name let-row>
                  <span data-cy="referral-client-name-{{row.index}}">{{row.model.ReferralClientName}}</span>
                </ng-template>
              </tdo-table-column>
            </tdo-table>
          </div>
        </div>
      </mat-card>
    </mat-grid-tile>
    <mat-grid-tile colspan="4" data-cy="referral-client-detail-tile">
      <mat-card appearance="outlined" style="width:100%; height:100%;" data-cy="referral-client-detail-card">
        <div style="height: 100%; width: 100%; max-width: 700px;" data-cy="referral-client-detail-content">
          <span class="configuration-section-title" data-cy="referral-client-detail-title">Client Information</span>
          <app-tdo-configuration-action-bar (newClick)="onNew($event)"
                                            (saveClick)="onSave(fromForm)"
                                            data-cy="referral-client-action-bar"></app-tdo-configuration-action-bar>
          <mat-card-content style="height: 100%;" data-cy="referral-client-form-container">
            <div *ngIf="selectedReferralEntity"
              style="display: flex; flex-direction: column; width: 100%; height: 100%; max-height: 100%; overflow-y: hidden;"
              data-cy="referral-client-form">
              <div style="display: flex;" data-cy="referral-client-name-container">
                <app-tdo-input style='width: 80%;' placeholder="Referral Client Name"
                               (input)="onNameInput($event); configurationService.setDirty();"
                               [(ngModel)]="selectedReferralEntity.ReferralClientName"
                               data-cy="referral-client-name-input"></app-tdo-input>
                <button mat-mini-fab color="primary"
                        (click)="openOrganization(false, this.selectedReferralEntity.OrganizationID)"
                        data-cy="referral-client-org-button">
                  <mat-icon>home</mat-icon>
                </button>
              </div>
              <div *ngIf="this.selectedReferralEntity.Organization"
                   style="display: flex;flex-direction: column; padding-left: 30px"
                   data-cy="referral-client-org-info">
                <div style="display: inline-flex; flex-direction: row" data-cy="referral-client-org-name-row">
                  <span class="span-bold" data-cy="referral-client-org-name-label">Organization:</span>
                  <span class="span-right" data-cy="referral-client-org-name-value">{{this.selectedReferralEntity.Organization.Name}}</span>
                </div>
                <div style="display: inline-flex; flex-direction: row" data-cy="referral-client-contact-row">
                  <span class="span-bold" data-cy="referral-client-contact-label">Contact:</span>
                  <span class="span-right" data-cy="referral-client-contact-value">{{this.selectedReferralEntity.Organization.ContactFullName}}</span>
                </div>
                <div style="display: inline-flex; flex-direction: row" data-cy="referral-client-tel-row">
                  <span class="span-bold" data-cy="referral-client-tel-label">Tel:</span>
                  <span class="span-right" data-cy="referral-client-tel-value">{{this.selectedReferralEntity.Organization.ContactPhone}}</span>
                </div>
                <div style="display: inline-flex; flex-direction: row" data-cy="referral-client-email-row">
                  <span class="span-bold" data-cy="referral-client-email-label">Email:</span>
                  <span class="span-right" data-cy="referral-client-email-value">{{this.selectedReferralEntity.Organization.ContactEmail}}</span>
                </div>
                <div style="display: inline-flex; flex-direction: row" data-cy="referral-client-address-row">
                  <span class="span-bold" data-cy="referral-client-address-label">Address:</span>
                  <div style="display: inline-flex; flex-direction: column" data-cy="referral-client-address-values">
                    <span class="span-right" data-cy="referral-client-address-upper">{{this.selectedReferralEntity.Organization.AddressUpper}}</span>
                    <span class="span-right" data-cy="referral-client-address-bottom">{{this.selectedReferralEntity.Organization.AddressBottom}}</span>
                  </div>
                </div>
              </div>
              <div *ngIf="!this.selectedReferralEntity.Organization"
                   style="display: flex;flex-direction: column; padding-left: 30px"
                   data-cy="referral-client-no-org-info">
                <div style="display: inline-flex; flex-direction: row" data-cy="referral-client-no-org-name-row">
                  <span class="span-bold" data-cy="referral-client-no-org-name-label">Organization:</span>
                </div>
                <div style="display: inline-flex; flex-direction: row" data-cy="referral-client-no-contact-row">
                  <span class="span-bold" data-cy="referral-client-no-contact-label">Contact:</span>
                </div>
                <div style="display: inline-flex; flex-direction: row" data-cy="referral-client-no-tel-row">
                  <span class="span-bold" data-cy="referral-client-no-tel-label">Tel:</span>
                </div>
                <div style="display: inline-flex; flex-direction: row" data-cy="referral-client-no-email-row">
                  <span class="span-bold" data-cy="referral-client-no-email-label">Email:</span>
                </div>
                <div style="display: inline-flex; flex-direction: row" data-cy="referral-client-no-address-row">
                  <span class="span-bold" data-cy="referral-client-no-address-label">Address:</span>
                  <div style="display: inline-flex; flex-direction: column" data-cy="referral-client-no-address-values">
                  </div>
                </div>
              </div>
              <div style="flex-basis: fit-content; padding-left: 5px; padding-top: 20px; width: 65%" data-cy="referral-client-providers-container">
                <span class="span-bold" data-cy="referral-client-providers-label">Provider Doctors</span>
                <tdo-dropdown-v2
                  [isMultiSelect]="true"
                  [isIncludeAll]="true"
                  [isPreventMouseEventPropagation]="true"
                  [datasource]="this.staticDataService.currentLocationDoctors" [displayPredicate]="doctorPredicate"
                  [value]="selectedProviders"
                  (selectionChange)="onDoctorsSelected($event)"
                  (closed)="onDoctorsSelected($event)"
                  style="width: 50%"
                  data-cy="referral-client-providers-dropdown">
                </tdo-dropdown-v2>
              </div>
              <div style="flex-basis: fit-content; padding-left: 5px; padding-top: 20px; width: 65%" data-cy="referral-client-url-container">
                <div style="display: inline-flex; flex-direction: row" data-cy="referral-client-url-row">
                  <span class="span-bold" data-cy="referral-client-url-label">URL:</span>
                  <span class="span-right" data-cy="referral-client-url-value">{{this.currentURL}}</span>
                </div>
                <div style="display: inline-flex; flex-direction: row; padding-top: 20px" data-cy="referral-client-token-row">
                  <span class="span-bold" data-cy="referral-client-token-label">Token:</span>
                  <div style="display: inline-flex; flex-direction: column; width: 300px" data-cy="referral-client-token-values">
                    <span class="span-right" data-cy="referral-client-token-entity">ReferralEntityID,</span>
                    <span class="span-right" data-cy="referral-client-token-tdocid">TDOCID,</span>
                    <span class="span-right" data-cy="referral-client-token-enterprise">EnterpriseID</span>
                  </div>
                  <button mat-button class="tdo-button tdo-save" (click)="generateToken()"
                          [attr.data-cy]="'GenerateTokenButton'" data-cy="referral-client-generate-token-button">Generate
                  </button>
                </div>
              </div>
              <div style="flex-basis: fit-content; padding-left: 5px; padding-top: 20px; width: 65%" data-cy="referral-client-iframe-container">
                <div style="display: inline-flex; flex-direction: row" data-cy="referral-client-iframe-row">
                  <span class="span-bold" data-cy="referral-client-iframe-label">IFrame URL:</span>
                  <div style="display: inline-flex; flex-direction: column; width: 375px" data-cy="referral-client-iframe-values">
                    <div style="display: flex; flex-direction: row" data-cy="referral-client-iframe-url-row">
                      <span class="span_URL" data-cy="referral-client-iframe-url">{{this.selectedReferralEntity.URL}}</span>
                      <button mat-icon-button color="primary" [cdkCopyToClipboard]=this.selectedReferralEntity.URL style="margin-left: 5px" matTooltip="Copy URL" data-cy="referral-client-copy-url-button">
                        <mat-icon>file_copy</mat-icon>
                      </button>
                    </div>
                    <button mat-button class="tdo-button tdo-save" (click)="sendEmail()"
                            [disabled]="CheckIfSendEmailDisabled()"
                            [attr.data-cy]="'SendEmailButton'" style="margin-left: auto; margin-top: 10px" data-cy="referral-client-send-email-button">Send
                      Email
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </mat-card-content>
        </div>
      </mat-card>
    </mat-grid-tile>
  </mat-grid-list>
</div>

